import { render, staticRenderFns } from "./CollectionGridFooter.vue?vue&type=template&id=3869b9b7&scoped=true&lang=pug&"
import script from "./CollectionGridFooter.vue?vue&type=script&lang=js&"
export * from "./CollectionGridFooter.vue?vue&type=script&lang=js&"
import style0 from "./CollectionGridFooter.vue?vue&type=style&index=0&id=3869b9b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3869b9b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3869b9b7')) {
      api.createRecord('3869b9b7', component.options)
    } else {
      api.reload('3869b9b7', component.options)
    }
    module.hot.accept("./CollectionGridFooter.vue?vue&type=template&id=3869b9b7&scoped=true&lang=pug&", function () {
      api.rerender('3869b9b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionGridFooter.vue"
export default component.exports